export enum ErrorType {
  AccessForbidden = 'AccessForbidden',
  VendorForbidden = 'VendorForbidden',
  UserForbidden = 'UserForbidden',
  SomethingWentWrong = 'SomethingWentWrong',
  CouldNotConnectToOrganization = 'CouldNotConnectToOrganization',
  NoInternetConnection = 'NoInternetConnection',
  Timeout = 'Timeout',
  NetworkError = 'NetworkError',
}
export enum ApiErrorType {
  VendorUnauthorizedException = 'VendorUnauthorizedException',
  ForbiddenException = 'ForbiddenException',
}

export function getForbiddenErrorType(apiErrorType?: string): ErrorType {
  if (apiErrorType === ApiErrorType.VendorUnauthorizedException) return ErrorType.VendorForbidden;
  if (apiErrorType === ApiErrorType.ForbiddenException) return ErrorType.UserForbidden;
  return ErrorType.AccessForbidden;
}
